import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { CaseService } from '../../services/case.service';
import { LookupService } from '../../services/lookup.service';
import { SharedHttpService } from '../../services/shared-http.service';
import { DateFormatterService } from '../date-picker/date-formatter.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-members',
    templateUrl: './members.component.html',
    styleUrls: ['./members.component.scss']
})
export class MembersComponent implements OnInit {
    @Input() caseId: any;
    @Input() eCaseId: any;
    @Input() concealmentCase: boolean;
    isOffenderCase:boolean = false;
    prosecutionId: any;
    prosecutionArr: any;
    isMemberFromCase:boolean=false;
    membersOnCaseArr:any=[];
    memberIdSelectedInAddFromCase:any;
    memberFromCaseOffender:any;
    isEditedObjHasCase=false;

    closeResult: string;
    inputMethod: string = 'manual';
    sneakiesArr: any = []; //motstreen
    sneakyAboutThemArr: any = [] //motstreen 3alihom
    partiesCaseNotAccusedArr: any = []; //3'er mothmeen
    offendersArr: any = []; // mo5alfeen fe el3'esh
    plaintiffsArr:any=[]; // el mod3yeen lw caseTypeId==4
    memberTypesArr: any = [];
    memberTypesArrEdit: any = [];
    memberTypeId: any;
    personName: any;
    fullNationalityArr: any = [];
    nationalityArr: any = [];
    nationaltyId: any;
    memberStatusArr: any = [];
    memberStatusId: any;
    identityOrIqamaNumber: string = '';
    description: any;
    notes: any;
    isMain: any;
    dateOf: any;
    caseMemberId: any;
    editedObj: any;
    identityTypesArr: any = [];
    identityTypeId: any;
    // isValidIqamaNumber: boolean = true;
    isValidIdentityNumber: boolean = true;
    personsInCompanyAddPersonModalArr: any = [];
    personsInCompanyAddPersonModalId: any;
    reason: any;
    email: any;
    mobile: any;
    caseDetails: any;
    maxdate: NgbDateStruct;
    maxhijdate: NgbDateStruct;
    date: { year: number, month: number };
    cityId:any;
    cities;
   

    constructor(private dateformat: DateFormatterService, private sharedService: SharedHttpService, public caseService: CaseService, private lookupService: LookupService, public toastr: ToastrService) { }
    @Input() loadDataFP: Observable<any>;
    ngOnInit(): void {
        let  currentdate = new Date();
        this.maxdate = { year: currentdate.getFullYear(), month: currentdate.getMonth() + 1, day: currentdate.getDate() };
        this.maxhijdate = this.dateformat.GetTodayHijri();
        this.loadDataFP.subscribe((data) => {
          this.eCaseId = data.eCaseId;
          setTimeout(() => {
            this.loadData();
          }, 100);
  
        });
        
    }
    

    loadData() {
        this.memberTypesArr = this.lookupService.getLockup('membertype');
        this.prosecutionArr = this.lookupService.getLockup('prosecution');
        this.caseId = ( this.caseService.case != null && this.caseService.case != undefined)? this.caseService.case.caseId:null;
        console.log(this.caseId);
        // this.concealmentCase
            this.caseDetails = this.caseService.case;
            if (this.caseDetails.caseTypeId == 1) { //تستر تجاري
                this.memberTypesArr = [
    
                    {
                        "id": 2,
                        "text": "متستر ",
                        "more": null
                    },
                    {
                        "id": 3,
                        "text": "متستر عليه",
                        "more": null
                    },
                    //{
                    //    "id": 1,
                    //    "text": "شاهد ",
                    //    "more": null
                    //},
                    //,
                    //{
                    //    "id": 4,
                    //    "text": "مشتبه به",
                    //    "more": null
                    //},
                    {
                        "id": 7,
                        "text": "مبلغ عن السجل",
                        "more": null
                    },
    
    
    
    
    
                ];
            }
            
            else if (this.caseDetails.caseTypeId == 2 || this.caseDetails.caseTypeId == 3) { //غسيل اموال //غش تجاري
                this.memberTypesArr = [
                    {
                        "id": 5,
                        "text": "مخالف",
                        "more": null
                    }
                 //  ,
                 //  {
                 //      "id": 1,
                 //      "text": "شاهد",
                 //      "more": null
                 //  }
                    //,
                    //{
                    //    "id": 4,
                    //    "text": "مشتبه به",
                    //    "more": null
                    //}
    
                ];
            }
    
            else if (this.caseDetails.caseTypeId == 4) {//شركات
                this.memberTypesArr = [
                    {
                        "id": 5,
                        "text": "مخالف",
                        "more": null
                    }
    
                    ,
                    {
                        "id": 6,
                        "text": "مدعي",
                        "more": null
                    }
                ];
            }
            else {
                this.memberTypesArr = [
                    {
                        "id": 5,
                        "text": "مخالف",
                        "more": null
                    }
                 //   ,
                 //   {
                 //       "id": 1,
                 //       "text": "شاهد",
                 //       "more": null
                 //   }
                    //,
                    //{
                    //    "id": 4,
                    //    "text": "مشتبه به",
                    //    "more": null
                    //}
    
                ];
            }
            this.sharedService.get(`api/Company/GetCompanyById?Id=${this.caseDetails.companyId}`).subscribe(res => {
                this.personsInCompanyAddPersonModalArr = res.crRelatedPrsons;
            })
       


        //if (this.caseDetails.caseType.concealmentInMembers) {
        //    this.memberTypesArr.pop();
        //}else if (this.caseDetails.caseType.id==4){
        //    this.memberTypesArr.splice(0,4)
        //}  else {
            
        //    this.memberTypesArr.splice(1, 2);
        //    this.memberTypesArr.pop();

        //}

        this.memberStatusArr = this.lookupService.getLockup('memberstatus');
        this.fullNationalityArr = this.lookupService.getLockup('nationalities');
        this.nationalityArr=[...this.fullNationalityArr];
        this.identityTypesArr = this.lookupService.getLockup('identitytypes');
        this.sneakiesArr = [];
        this.sneakyAboutThemArr = [];
        this.offendersArr = [];
        this.partiesCaseNotAccusedArr = [];
        this.plaintiffsArr=[];
        let url ='';
        url = `api/CaseMember/GetCaseMembers?ecaseId=${this.eCaseId}` ; 
        this.sharedService.get(url).subscribe(res => {
                res.map(el => {
                    if (el.memberTypeId == 2 && this.sneakiesArr.findIndex(a => a.caseMemberId == el.caseMemberId) < 0) {
                        this.sneakiesArr.push(el);
                    } else if (el.memberTypeId == 3 && this.sneakyAboutThemArr.findIndex(a => a.caseMemberId == el.caseMemberId) < 0) {
                        this.sneakyAboutThemArr.push(el);
                    } else if ((el.memberTypeId == 5 || el.memberTypeId == 4) && this.offendersArr.findIndex(a => a.caseMemberId == el.caseMemberId) < 0) {
                        this.offendersArr.push(el);
                    } else if (el.memberTypeId == 6 && this.plaintiffsArr.findIndex(a => a.caseMemberId == el.caseMemberId) < 0) {
                        this.plaintiffsArr.push(el);
                    }
                    else {
                        if ((el.memberTypeId == 1 || el.memberTypeId == 6 || el.memberTypeId == 4  )   && this.partiesCaseNotAccusedArr.findIndex(a => a.caseMemberId == el.caseMemberId) < 0)
                              this.partiesCaseNotAccusedArr.push(el);
                    }
                })
           
        });
    }
    selectIdentityType() {
        this.identityOrIqamaNumber = '';
        this.isValidIdentityNumber = true;
        this.nationalityArr=[...this.fullNationalityArr];
        if(this.identityTypeId===1){
          this.nationaltyId=1;
        }else if(this.identityTypeId===2 || this.identityTypeId===4 || this.identityTypeId===5){
          this.nationaltyId=undefined;
          this.nationalityArr.shift();
        }else if(this.identityTypeId===3){
          this.nationalityArr=[];
          this.fullNationalityArr.map(el=>{
              if(el.id === 192 ||el.id === 7 || el.id === 27 || el.id === 3 ){
                  this.nationalityArr.push(el);
              }
          })
  
        }
      }
 
    inputMethodSelect(string) {
        this.inputMethod = string;
        this.identityOrIqamaNumber = undefined;
        this.identityTypeId = undefined;
        this.dateOf = undefined;
        this.personName = undefined;
        this.personsInCompanyAddPersonModalId = undefined;
        this.nationaltyId = undefined;

    }

    numberOnly(event) {
        // var inp = String.fromCharCode(event.keyCode);
        // let pattern = /^\d+$/;
        let isIdentityNumHasChar = isNaN(+this.identityOrIqamaNumber);
        if(this.identityTypeId ==1 || this.identityTypeId ==2){
            this.isValidIdentityNumber=false;
            if(this.identityOrIqamaNumber.startsWith('3') && this.identityOrIqamaNumber.length ==10 && !isIdentityNumHasChar){
                this.isValidIdentityNumber=true;
            }else{
                if(isIdentityNumHasChar){
                    this.isValidIdentityNumber=false;
                }else{
                    this.isValidIdentityNumber=this.sharedService.isValidSaudiID(this.identityOrIqamaNumber);

                }
            }
        }else{
            this.isValidIdentityNumber=true;
        }
        console.log(this.identityOrIqamaNumber,this.isValidIdentityNumber)

        // if (pattern.test(inp)) {
        //     return true;
        // } else {
        //     event.preventDefault();
        //     return false;
        // }
    }
    SelectedDateChange($event) {
        this.dateOf = this.dateformat.ToGregorian2($event);
    }
    SelectedHijriDateChange($event) {
        this.dateOf = this.dateformat.ToHijri2($event);
    }
    changeMemberType() {
        this.nationalityArr = [];

        this.nationalityArr = [...this.fullNationalityArr];
        if (this.memberTypeId == 1) {
            this.isMain = undefined;
        }
        if (this.editedObj && this.editedObj.memberTypeId == 1) {
            this.editedObj.isMain = undefined;
        }

        if (this.memberTypeId == 2 && this.identityTypeId != 1) {
            this.identityTypeId = 1;
            // this.selectIdentityType();
        } else if (this.memberTypeId == 3 && this.identityTypeId != 2) {
            this.identityTypeId = 2;
            // this.selectIdentityType();
        }

        if (this.memberTypeId == 2) {
            this.nationaltyId = 1;
        } else if (this.memberTypeId == 3) {
            if (this.nationaltyId == 1) {
                this.nationaltyId = undefined;
            }
            this.nationalityArr.splice(0, 1);
        }

    }
    selectPersonINCompany(event) {
        
        if (event) {
            this.identityOrIqamaNumber = event.identityNumber;
            this.identityTypeId = event.identityTypeId;
            this.nationaltyId = event.nationalityId;
            this.personName = event.name;

            // this.nationalityArr = [];
            // for (var i = 0; i < this.fullNationalityArr.length; i++) {
            //     if (this.fullNationalityArr[i].id === event.nationalityId) {
            //         this.nationalityArr.push(this.fullNationalityArr[i])
            //     }
            // }
        }
        else {
            // this.nationalityArr = this.fullNationalityArr;
            this.identityOrIqamaNumber = undefined;
            this.identityTypeId = undefined;
            this.nationaltyId = undefined;
            this.personName = undefined;
        }
    }

    openModal(addModal) {
        this.memberTypeId = undefined;
        this.identityOrIqamaNumber = undefined;
        this.personName = undefined;
        this.memberStatusId = undefined;
        this.nationaltyId = undefined;
        this.description = undefined;
        this.notes = undefined;
        this.isMain = undefined;
        this.dateOf = undefined;
        this.reason = undefined;
        this.email = undefined;
        this.mobile = undefined;
        this.isMemberFromCase=false;
        this.prosecutionId=undefined;
        this.identityTypeId=undefined;
        this.cityId=undefined;
        this.sharedService.openXLarge(addModal);
    }
 
    onSelectMemberFromCaseOffenders(e){
        if(e){
            this.memberFromCaseOffender=e;
            this.personName=e.name;
            this.identityOrIqamaNumber=e.nationIdOrIqama;
            this.nationaltyId=e.nationalityId;
            this.mobile=e.mobile;
            this.email=e.email;
            this.description=e.description;
            this.notes=e.notes
        }else{
            this.personName=undefined;
            this.memberTypeId=undefined;
            this.identityOrIqamaNumber=undefined;
            this.nationaltyId=undefined;
            this.mobile=undefined;
            this.email=undefined;
        }
    }
    getYaqeenInfo(){
        this.sharedService.get(`api/Ingeration/GetYaqeenInfo?id=${this.identityOrIqamaNumber}&date=${this.dateOf}`).subscribe(res=>{
        
            if (res != null) {
                this.personName = res.nameAr != null && res.firstNameAr != null? res.nameAr:null;
                // this.nationaltyId = res.nationalityCode;
            }
            


            console.log(res);
        })
    }



    CreateMember(modal) {
        if(this.memberTypeId==6){
            this.isMain=true;
            this.memberStatusId=1;
        }
        let obj = {
            "caseId":   this.caseId,
            "memberTypeId":  this.memberTypeId ,
            "nationIdOrIqama": this.identityOrIqamaNumber,
            "name": this.personName,
            "memberStatusId": this.memberStatusId,
            "nationalityId": this.nationaltyId,
            "description": this.description,
            "notes": this.notes,
            "isMain": this.isMain,
            "hasCriminalRecord": false,
            "dateOf": this.dateOf,
            "reason": this.reason,
            "email": this.email,
            "mobile": this.mobile,
            "prosecutionId" : this.prosecutionId,
            "cityId" : this.cityId,
            "identityTypeId":this.identityTypeId
        }
        this.sharedService.post('api/CaseMember/Insert', [obj]).subscribe(res => {
            modal.dismiss('Cross click');
            this.sharedService.showSuccessKey("CaseMemberAdded");
            this.loadData();
        })

    }
    deleteMember(memberId: any, mymodal) {
        this.sharedService.openXLarge(mymodal);
        this.caseMemberId = memberId;
    }
    onDeleteMember(modal) {
        let url = `api/CaseMember/DeleteCaseMember?caseMemberId=${this.caseMemberId}`;
        this.sharedService.get(url ).subscribe((res) => {
            modal.dismiss('Cross click');
            this.sharedService.showSuccessKey("DeletedSuccessfully");
            this.loadData();
        });
    }
    editMember(member, modal) {
        this.isEditedObjHasCase=false;
        this.editedObj = {};
        this.editedObj = { ...member };
       
        this.memberTypesArrEdit=[];
        this.memberTypesArrEdit = [...this.memberTypesArr];


        this.nationalityArr=[...this.fullNationalityArr];
        if(this.editedObj.identityTypeId===1){
          this.editedObj.nationaltyId=1;
        }else if(this.editedObj.identityTypeId===2){
          this.nationalityArr.shift();
        }else if(this.editedObj.identityTypeId===3){
          this.nationalityArr=[];
          this.fullNationalityArr.map(el=>{
            if(el.id === 192 ||el.id === 7 || el.id === 27 || el.id === 3 ){
              this.nationalityArr.push(el);
            }
          })
        }

        // if(this.concealmentCase){
        //     if (this.editedObj.nationIdOrIqama.startsWith('1')) {
        //         this.memberTypesArrEdit.splice(2, 1)
        
        //     } else if (this.editedObj.nationIdOrIqama.startsWith('2')) {
        //         this.memberTypesArrEdit.splice(1, 1);
        //     }
        // }
        this.sharedService.openXLarge(modal);
    }
    onEditMember(modal) {
        if(this.editedObj.memberTypeId==6){
            this.editedObj.isMain=true;
            this.editedObj.memberStatusId=1;
        }
        let obj = {
            "caseMemberId": this.editedObj.caseMemberId,
            "caseId":  this.caseId,
            "memberTypeId": this.editedObj.memberTypeId,
            "nationIdOrIqama": this.editedObj.nationIdOrIqama,
            "name": this.editedObj.name,
            "memberStatusId": this.editedObj.memberStatusId,
            "nationalityId": this.editedObj.nationalityId,
            "description": this.editedObj.description,
            "notes": this.editedObj.notes,
            "isMain": this.editedObj.isMain,
            "hasCriminalRecord": this.editedObj.hasCriminalRecord,
            "dateOf": this.editedObj.dateOf,
            "reason": this.editedObj.reason,
            "email": this.editedObj.email,
            "mobile": this.editedObj.mobile,
            "prosecutionId" : this.editedObj.prosecutionId,
            "cityId" : this.editedObj.cityId,
            "identityTypeId":this.editedObj.identityTypeId

        };

        this.sharedService.post  ('api/CaseMember/UpdateCaseMembers', [obj]).subscribe(res => {
            modal.dismiss('Cross click');
            this.sharedService.showSuccessKey("CaseMemberEdited");
            this.loadData();
        })

    }

    previewMember(member, modal) {
        this.editedObj = {};
        this.editedObj = { ...member };
        this.sharedService.openLarge(modal);
    }

}
